import * as React from 'react';
import { useState } from 'react';

export interface RetireProblemModalComponentProps {
    itemId: string
    problemId: number
    buttonFunction: Function
}

const RetireProblemModalComponent = (props: RetireProblemModalComponentProps) => {
    const [reason, setReason] = useState("")

    return (
        <div className="modal fade" id={props.itemId} tabIndex={-1} >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">Are you sure?</h3>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <p>
                            Would you like to delete this problem? Assignments using this problem will keep a copy of this problem and their owners will receive an email with your reason for deletion.
                        </p>
                        <label>
                            <b>
                                Deletion Reason:
                            </b>
                        </label>
                        <textarea className="form-control" value={reason} onChange={e => setReason(e.target.value)} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <a href="#"><button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={() => props.buttonFunction(props.problemId, reason)}>Delete Problem</button></a>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default RetireProblemModalComponent;